import { display } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useNavigate, useHistory, useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { useMediaQuery } from "react-responsive";
import {
    authTokenHandler,
    employeeNoHandler,
    locationsHandler,
    displayNameHandler,
    userNameHandler,
    emailHandler,
    roleHandler,
    locationHandler,
    sessionHandler,
    passwordExpireHandler,
    rolesHandler,
    pageAccessHandler,
    positionlHandler,
    locationNameHandler,
    permissionAccessHandler,
    pageMenuHandler,
    checkinLocationHandler
} from "../util/local-storage";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { saveLog } from '../pages/Master/hook/useUserApi'
import { getProfile, logout } from '../pages/Auth/hook/useLogin'
import { menuLookup } from "../pages/Master/hook/useMenuApi";
const Layout = ({ children, pageName, pageCode }) => {



    const [displayMenu, setDispayMenu] = useState(
        pageName === "Login" ||
            pageName === "resetPassword" ||
            pageName === "change-Password"
            ? true
            : false
    );
    const navigate = useNavigate();
    const role = useState(roleHandler.get());

    const roles = JSON.parse(rolesHandler.get())?.map(it => it.roleCode);
    const pageAccess = JSON.parse(pageAccessHandler.get()) ?? [];

    const passwordExpire = passwordExpireHandler.get();
    const isMobile = useMediaQuery({ query: `(max-width: 767px)` });

    const hasInitAuditQtn = useRef(false);

    /*
    const logoutHandler = () => {

        logout().then((result) => {

            const { code, status, data, message, description } = result;

            if (status === 200 || code === 200) {
                sessionHandler.clear();
                setDispayMenu(true);

            }

        }).catch(error => {

            setOpenDialog(true);
            setLoadingPageFlag(2);
            console.error(error.message);
        });;

    }
        */
    const logoutHandler = async () => {
        try {
            const result = await logout();
            const { code, status } = result;

            if (status === 200 || code === 200) {
                sessionHandler.clear();
                setDispayMenu(true);
            } else {
                sessionHandler.clear();
            }

        } catch (error) {
            setOpenDialog(true);
            setLoadingPageFlag(2);
            console.error(error.message);
        }
    }

    useEffect(() => {


        if (authTokenHandler.get() != null) {

            try {
                let param = {};
                param.name = pageName ?? '';
                param.path = pageCode ?? '';

                if (!pageName?.includes("logout") || !pageName?.includes("login") || !pageName?.includes("Home")) {
                    saveLog(param).then((result) => {

                    })
                }

            } catch (ex) {

            }


        }


    }, [pageName, pageCode])

//     const setProfileWithQparam = async (data,location) => {

//   // ⭐⭐⭐ ใส่ตรงนี้เป็นบรรทัดแรก
//   const token = data.replace(/^Bearer\s+/i, '');
//   authTokenHandler.set(`Bearer ${token}`);
  
//   const checkinlocationFromUrl = location

//   // จากนั้นค่อยทำอย่างอื่น
//   const lookupMenu = await menuLookup();

//   const result = await getProfile(token);
//   if(result.status === 401){
//       hasInitAuditQtn.current = true; // 🔒 ปิด loop
//       localStorage.clear();
//   navigate("/login", { replace: true });
//   return;
//   }
//   const { status, data: dataProfile, message } = result;

//   if (status == 200) {

//     const masterMenu = lookupMenu?.data?.content;

//     employeeNoHandler.set(dataProfile.employeeNo);
//     locationsHandler.set(dataProfile.locations);
//     displayNameHandler.set(dataProfile.displayName);
//     userNameHandler.set(dataProfile.userName);
//     emailHandler.set(dataProfile.email);
//     roleHandler.set(dataProfile.role?.toUpperCase());
//     locationHandler.set(dataProfile.location);
//     positionlHandler.set(dataProfile.position);
//     locationNameHandler.set(dataProfile.location_Desc);
//     passwordExpireHandler.set(dataProfile.password_Expired);
//     rolesHandler.set(JSON.stringify(dataProfile.roles));
//     permissionAccessHandler.set(JSON.stringify(dataProfile.permissionAccess));
//     pageMenuHandler.set(JSON.stringify(dataProfile.webScreen));
//     checkinLocationHandler.set(checkinlocationFromUrl);

//     var pagePath = dataProfile.pageAccess.map(ch1 => {
//     return masterMenu?.filter(m => m.menu_Code === ch1)[0];
// });

//     const accessPaths = [
//         ...pagePath.map(i => i?.location_Path ?? ''),
//         "/auditqtn"
//     ];

//     // กันซ้ำ เผื่อ backend ส่งมาแล้ว
//     const uniqueAccessPaths = [...new Set(accessPaths)];

//     pageAccessHandler.set(JSON.stringify(uniqueAccessPaths));

 
//     if(pageName !== "Audit Qtn"){
//     navigate('/', { replace: true });
//     }
//     if (pageName === "Audit Qtn") {
//     //   window.history.replaceState({}, document.title, window.location.pathname);
//     }

//   } else {
//     setOpenDialog(true);
//     setLoadingPageFlag(2);
//   }
// };



      const setProfileWithQparam = async (data, location) => {
  const token = data.replace(/^Bearer\s+/i, '');
  authTokenHandler.set(`Bearer ${token}`);
  
  const checkinlocationFromUrl = location;
  const lookupMenu = await menuLookup();
  const result = await getProfile(token);

  if (result.status === 401) {
    
    // ✅ ลบ hasInitAuditQtn.current = true ออก
    localStorage.clear();
    navigate("/login", { replace: true });
    return;
  }
  const { status, data: dataProfile, message } = result;

  if (status == 200) {

    const masterMenu = lookupMenu?.data?.content;

    employeeNoHandler.set(dataProfile.employeeNo);
    locationsHandler.set(dataProfile.locations);
    displayNameHandler.set(dataProfile.displayName);
    userNameHandler.set(dataProfile.userName);
    emailHandler.set(dataProfile.email);
    roleHandler.set(dataProfile.role?.toUpperCase());
    locationHandler.set(dataProfile.location);
    positionlHandler.set(dataProfile.position);
    locationNameHandler.set(dataProfile.location_Desc);
    passwordExpireHandler.set(dataProfile.password_Expired);
    rolesHandler.set(JSON.stringify(dataProfile.roles));
    permissionAccessHandler.set(JSON.stringify(dataProfile.permissionAccess));
    pageMenuHandler.set(JSON.stringify(dataProfile.webScreen));
    checkinLocationHandler.set(checkinlocationFromUrl);

    var pagePath = dataProfile.pageAccess.map(ch1 => {
    return masterMenu?.filter(m => m.menu_Code === ch1)[0];
});

    const accessPaths = [
        ...pagePath.map(i => i?.location_Path ?? ''),
        "/auditqtn"
    ];

    // กันซ้ำ เผื่อ backend ส่งมาแล้ว
    const uniqueAccessPaths = [...new Set(accessPaths)];

    pageAccessHandler.set(JSON.stringify(uniqueAccessPaths));

 
    if(pageName !== "Audit Qtn"){
    navigate('/', { replace: true });
    }
    if (pageName === "Audit Qtn") {
    //   window.history.replaceState({}, document.title, window.location.pathname);
    }

  } else {
    setOpenDialog(true);
    setLoadingPageFlag(2);
  }
};




    function LayoutDesktop(childPage) {
        return (
            <>
                <div style={{ display: "grid" }} className="   font-prompt">
                    <Navbar />
                    <div className="div-main">
                        <div>
                            <div className="flex bg-gray-panel">
                                <div className="slide-bg-expand slide-bg-expand-margin">
                                    <Sidebar />
                                </div>

                                <div className=" grow panel-body  div-overflow-auto">
                                    <div>
                                        <div className="m-5   ">
                                            {children}
                                            {role !== null ? (
                                                <ToastContainer transition={Zoom} limit={1} />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className=" clear-both h-1" style={{ background: "#fff" }}>
                    <div className="  panel-search-detail p-1 text-gray-400">
                        <div className="w-12/12 text-center">
                            <span className="font-bold">Copyright </span>
                            <span>© 2023 Laundry You Company Limited (Version 1.2.8)</span>
                        </div>

                    </div>
                </footer>

            </>
        );
    }
    function LayoutMobile(childPage) {
        return (
            <>
                <div>
                    <Navbar />
                </div>
                <div className=" panel-body-mb  ">
                    {childPage}
                    {role !== null ? (
                        <ToastContainer transition={Zoom} limit={1} />
                    ) : null}
                </div>
            </>
        );
    }
    function LayoutLogin(childPage) {
        return (
            <>
                <div>{children}</div>
            </>
        );
    }

    const CheckAccessPage = () => {
        //if (pageName === "Login" ||
        //    pageName === "resetPassword" ||
        //    pageName === "change-Password") {
        //    return true;
        //} else {
        //    var isAccessPage = pageAccess.find(p => p?.toLowerCase() === pageCode?.toLowerCase()) != null;
        //    return isAccessPage;
        //}
          if (pageCode?.toLowerCase() === "/auditqtn") {
            return true;
          }

        var isAccessPage = pageAccess.find(p => p?.toLowerCase() === pageCode?.toLowerCase()) != null;
        return isAccessPage;



    };

    useEffect(() => {
        let ShowToastyId;
        if (
          pageName === "Login" ||
          pageName === "resetPassword" ||
          pageName === "change-Password"
        ) {
          if (authTokenHandler.get() != null) {
            logoutHandler();
            //sessionHandler.clear();
            //setDispayMenu(true);
          } else {
            //sessionHandler.clear();
            //setDispayMenu(true);
          }
          //sessionHandler.clear();
          //setDispayMenu(true);
          sessionHandler.clear();
          setDispayMenu(true);
        } else if (pageName === "WXPNotify") {
          setDispayMenu(false);
        } else if (pageName === "Audit Qtn") {
  setDispayMenu(true);

  const query = new URLSearchParams(window.location.search);
  const tokenFromUrl = query.get("token");
  const checkinLocation = query.get("location");

  if (tokenFromUrl) {
    localStorage.clear()
    // ✅ call 1 ครั้งต่อ token — ถ้า token เดิมไม่ call ซ้ำ, ถ้า token ใหม่ call ใหม่
    if (hasInitAuditQtn.current === tokenFromUrl) return;
    hasInitAuditQtn.current = tokenFromUrl;
    setProfileWithQparam(tokenFromUrl, checkinLocation);

  } else {
     
    // ❌ ไม่มี token ใน URL เลย → login
    navigate("../login");
  }
        // } else if (pageName === "Audit Qtn") {
        //   setDispayMenu(true);

        //   // กันไม่ให้รันซ้ำ
        //   if (hasInitAuditQtn.current) return;

        //   const query = new URLSearchParams(window.location.search);
        //   const tokenFromUrl = query.get("token");
        //   const checkinLocation = query.get("location");

        //   if (tokenFromUrl && authTokenHandler.get() == null) {
        //     hasInitAuditQtn.current = true;

        //     // ⭐ 1) set token ก่อน
        //     setProfileWithQparam(tokenFromUrl, checkinLocation);

        //     // ⭐ 2) ค่อยไป set profile (ถ้ามี)
        //   }
          
        //   if (!tokenFromUrl && authTokenHandler.get() == null) {
        //     navigate("../login");
        //   }
        //   else {
        //     navigate("../login");
        //   }
        } else if (
             pageName !== "Audit Qtn" &&
             (
          pageName == "Logout" ||
          authTokenHandler.get() == null ||
          roleHandler.get() == null
        )
        ) {
          //
          //localStorage.clear();

          //console.log('authTokenHandler.get() : ', authTokenHandler.get());
          //console.log('roleHandler.get() : ', roleHandler.get());

          sessionHandler.clear();
          navigate("../login");
          setDispayMenu(true);
        } else if (pageName === "laundryyouupdate") {
          // localStorage.setItem('userName', 'updatelu')
          //localStorage.clear();
          sessionHandler.clear();
          setDispayMenu(true);
        } else if (!CheckAccessPage()) {
          setDispayMenu(false);
          navigate("/");
        } else {
          setDispayMenu(false);
        }

        let getShowTime = parseInt(localStorage.getItem("durationShow"), 10);
        const getDoingToasty = localStorage.getItem("DoingToasty");

        const checkPasswordExpiration = () => {
            const lastNotificationTime = localStorage.getItem("lastNotificationTime");
            const currentTime = new Date().getTime();
            const oneDayInMillis = 24 * 60 * 60 * 1000; //  x day in milliseconds



            if (
                getShowTime >= 1 ||
                !lastNotificationTime ||
                currentTime - lastNotificationTime > oneDayInMillis
            ) {
                const passwordHasExpire = new Date(passwordExpire?.toString());

                const passwordExpirationDate = passwordHasExpire;
                const today = new Date(); // Get today's date
                const daysBetweenExpire = 7;
                // Calculate the difference in milliseconds between the two dates
                const timeDifference =
                    passwordExpirationDate.getTime() - today.getTime();


                // Convert milliseconds to days
                const daysUntilExpiration = timeDifference / oneDayInMillis;

                const expirationThreshold = new Date(
                    passwordExpirationDate.getTime() +
                    daysUntilExpiration * oneDayInMillis
                );
                // set data to lc storage
                // if(!getShowTime || isNaN(getShowTime) || getShowTime == 0){
                localStorage.setItem(
                    "durationShow",
                    (expirationThreshold - passwordExpirationDate).toString(),
                    10
                );

                getShowTime = parseInt(localStorage.getItem("durationShow"), 10);

                const DateOptions = {
                    timeZone: "Asia/Bangkok",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                };
                // check date expire in 7 day ?
                if (daysUntilExpiration <= daysBetweenExpire) {
                    if (passwordExpirationDate.getTime() < currentTime) {
                        toast.error("รหัสผ่านของคุณหมดอายุแล้ว กรุณารีเซ็ตรหัสผ่าน", {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });
                        setTimeout(() => {
                            sessionHandler.clear();
                            setDispayMenu(true);
                            navigate("../login");
                        }, 3000);
                        return;
                    }
                    //change text if last 24 hrs before password expire
                    let warningText = `รหัสผ่านของคุณจะหมดอายุใน ${Math.ceil(
                        daysUntilExpiration
                    )} วัน กรุณาเปลี่ยนรหัสผ่านก่อน ${passwordExpirationDate.toLocaleString(
                        "th-TH",
                        DateOptions
                    )}`;
                    if (daysUntilExpiration < 1) {
                        warningText = `รหัสผ่านของคุณจะหมดอายุภายใน 24 ชั่วโมง  กรุณาเปลี่ยนรหัสผ่านก่อน ${passwordExpirationDate.toLocaleString(
                            "th-TH",
                            DateOptions
                        )}`;
                    }
                    // showing noti at first launch ( refresh include )
                    //   toast.warn(warningText, {
                    //     position: "top-center",
                    //     autoClose: 20000,
                    //     hideProgressBar: false,
                    //     pauseOnHover: true,
                    //     progress: undefined,
                    //     theme: "dark",
                    //     draggable: false,
                    //     closeOnClick: true,
                    //     closeButton: false,
                    //     pauseOnFocusLoss: false,
                    //   });
                    localStorage.setItem("lastNotificationTime", currentTime.toString());

                    ShowToastyId = setInterval(() => {
                        const checkTime = new Date();
                        const minutesinHours = checkTime.getMinutes();
                        // check if every 15 min show a noti
                        if (minutesinHours % 15 === 0) {

                            toast.warn(warningText, {
                                position: "top-center",
                                autoClose: 30000,
                                hideProgressBar: false,
                                pauseOnHover: true,
                                progress: undefined,
                                theme: "dark",
                                draggable: false,
                                closeOnClick: false,
                                closeButton: false,
                                pauseOnFocusLoss: false,
                            });
                        }
                        getShowTime -= 60000;
                        localStorage.setItem("durationShow", getShowTime.toString());
                        localStorage.setItem("DoingToasty", true);

                        // if expired logout clear localstorage
                        if (getShowTime <= 0) {
                            localStorage.removeItem("durationShow");
                            localStorage.removeItem("DoingToasty");
                            localStorage.removeItem("lastNotificationTime");
                            localStorage.removeItem("passwordExpire");
                            clearInterval(ShowToastyId);
                            sessionHandler.clear();
                            localStorage.clear();
                            setDispayMenu(true);
                            navigate("../login");
                            // Stop the interval if the time reaches zero or negative
                        }
                    }, 60000);

                    return () => {
                        clearInterval(ShowToastyId);
                    };
                }
            }
        };

        // if login dismiss toasty remove when refresh or change page  before start check PassWord Expiring Logic
        if (pageName !== "Login" && pageName !=="Audit Qtn" && passwordExpire !== (null || "null")) {

            
            toast.dismiss();
            const coretimer = setTimeout(checkPasswordExpiration, 1000);

            return () => {
                // clear timeout when refresh && change page location
                clearTimeout(coretimer);
                clearInterval(ShowToastyId);
            };
        }



    }, [pageName]);

    // pageName
    return (
        <>
            {displayMenu
                ? LayoutLogin(children)
                : isMobile
                    ? LayoutMobile(children)
                    : LayoutDesktop(children)}

            {/*<div style={{ display: displayMenu ? 'none' : 'block' }}>
                <div className='   font-prompt' >
                    <Navbar />
                    <div className='clear-both h-0'> </div>
                    <div></div>
                    <div className={isMobile ? "" : "flex"} >

                        <div className={isMobile ? "" : 'slide-bg-expand '} >
                            <Sidebar />
                        </div>

                        <div className=' grow panel-body  '>
                           
                            <div>
                                <div className='m-5   '>
                                    {children}
                                </div>

                            </div>
                            <div className=''></div>
                        </div>



                    </div>
                </div>
            </div>
            <div style={{ display: displayMenu ? 'block' : 'none' }} children="panel-container panel-body "   >
                {children}
            </div>*/}
        </>
    );
};

export default Layout;
